<template>
  <div>
    <v-app-bar app color="primary" dark >
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" absolute temporary>
      <!-- <v-list v-if="isVibefamAdmin">
        Add vibefam admin related tabs here
        <v-list-item v-for="item in vibefamAdminItems" :key="item.title" link :to="item.route">
          <v-list-item-icon>
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="primary--text">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list> -->
      <v-list v-if="!isStudioAdmin && !isVibefamAdmin">
        <!------ INSTRUCTORS -->
        <v-list-item v-for="item in items" :key="item.title" link :to="item.route">
          <v-list-item-icon>
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="primary--text">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- STUDIO OWNERS ONLY -->
      </v-list>
      <v-list v-if="isStudioAdmin">
        <v-list-item v-if="studioLogo !== undefined">
          <v-list-item-avatar>
            <v-img :src="studioLogo"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <h3 v-if="studioName !== undefined">{{studioName}}</h3>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-for="item in items" :key="item.title" link :to="item.route">
          <v-list-item-icon>
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="primary--text">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-for="item in adminItems" :key="item.title" link :to="item.route">
          <v-list-item-icon>
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="primary--text">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template>
        <v-spacer></v-spacer>
        <div>
          <v-btn depressed class="primary lighten-2" light block @click="logOut">
            <span class="text-capitalize">Log out</span>
          </v-btn>
          <v-btn class="my-5" dark depressed @click="debug">debug</v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { auth } from "@/firebase";
export default {
  props: {
    isStudioAdmin: Boolean,
    isVibefamAdmin: Boolean,
    studioLogo: String,
    studioName: String,
  },
  data() {
    return {
      // vibefamAdminItems: [
      //   { icon: "dashboard", title: "Overview", route: "/vibefamadmin" },
      // ],
      items: [{ icon: "dashboard", title: "Overview", route: "/dashboard" }],
      adminItems: [
        { icon: "mdi-calendar", title: "Schedule Class", route: "/schedule" },
        { icon: "card_membership", title: "Manage Members", route: "/members" },
        { icon: "supervisor_account", title: "Manage Staff", route: "/staff" },
        { icon: "table_chart", title: "Reports", route: "/reports" },
        { icon: "settings", title: "Configure", route: "/configure" },
      ],
      drawer: false,
    };
  },
  methods: {
    debug() {
      console.log('isStudioAdmin:' + this.isStudioAdmin)
      console.log('isVibefamAdmin:' + this.isVibefamAdmin)
    },
    logOut() {
      auth.signOut();
    },
  },
};
</script>
